<template lang="pug">
  div.frame(:style="sty()",:class="{ alert: alert }")
    div.caution(v-if="alert === true") この組み合わせは設置可能範囲を超えています
</template>

<script>
export default {
  name: 'Space',
  data () {
    return {
      timer: {},
      alert: false,
      width: 8440,
      height: 5280,
      left: 0
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    update () {
      let me = this;
      if (me.sets[me.number] !== undefined) {
        me.set = me.sets[me.number];
        me.width = me.c2p(me.set.space[0]) / 10;
        me.height = me.c2p(me.set.space[1]) / 10;
        me.left = me.c2p(me.set.left);
        clearTimeout(me.timer);
        me.timer = setTimeout(function () {
          if (me.set.alert) {
            me.alert = true;
          } else {
            me.alert = false;
          }
        }, 500);
      }
    },
    sty () {
      return {
        backgroundPosition: 'left ' + this.left + 'px bottom',
        width: this.width + 'px',
        height: this.height + 'px'
      };
    }
  },
  created () {
    this.update();
  }
};
</script>
<style lang="stylus" scoped>
  .caution
    font-size 13px
    font-weight bold
    color #cc0000
    text-align center
    padding-top 5px
  .frame
    position absolute
    left 0
    bottom 0
    background #ffffff url("../../assets/bg_grid.svg") 0 bottom
    user-select none
    &:before
      content ""
      position absolute
      display block
      left 0
      right 0
      top 0
      bottom 0
      border 2px dashed #bbbbbb
      .preview &
        border 1px dashed #dddddd
    &.alert:before
      border 4px dashed #cc0000
</style>



// WEBPACK FOOTER //
// src/components/front/Space.vue